import React from "react";
import styles from "./RadioButtonGroup.module.scss";
import clsx from "clsx";
import { Alert } from "@bale/icons";
import { getColorByName } from "../../utils/color";
import { ThemeColors } from "../../theme";
export const RadioButtonGroup = ({ title, children, divider = true, helpText, topPadding = true, }) => {
    return (React.createElement("div", { className: clsx(styles.RadioButtonGroup, {
            [styles.divider]: divider,
            [styles.dividerSpace]: helpText,
        }) },
        title,
        React.createElement("div", { className: clsx(styles.buttons, { [styles.topPadding]: topPadding }) }, children),
        helpText && (React.createElement("div", { className: styles.helpText },
            React.createElement(Alert, { size: 20, color: getColorByName(ThemeColors.color_neutrals_n_300) }),
            React.createElement("span", null, helpText)))));
};
//# sourceMappingURL=RadioButtonGroup.js.map